module.exports = __webpack_public_path__ + "img/dox-registration-success.8076229b.gif";